/**
 * Return an array of years (by default the last year will be the current year) starting 7 years ago.
 */
export const generateYearsBetween = (endYear = new Date().getFullYear(), startYear = endYear - 7) => {
  return Array(endYear - startYear)
    .fill(0)
    .map((_, index) => ({ name: (startYear + index).toString(), value: startYear + index }))
    .concat({ name: endYear.toString(), value: endYear })
    .reverse()
}

/**
 * Return an array of years (by default the last year will be the current year) starting 5 years ago.
 */
export const generateYears = (endYear = new Date().getFullYear(), startYear = endYear - 5) => {
  return Array(endYear - startYear)
    .fill(0)
    .map((_, index) => ({ name: (startYear + index).toString(), value: startYear + index }))
    .concat({ name: endYear.toString(), value: endYear })
    .reverse()
}

export default generateYearsBetween
